import { Tooltip } from '@mantine/core';
import { twMerge } from 'tailwind-merge';
import { timeAgo } from '~/common/time/timeAgo';

export default function TimeAgo({
  time,
  textStyle,
  disableTooltip,
  inverse,
}: {
  time: Date | undefined;
  textStyle?: string;
  disableTooltip?: boolean;
  inverse?: boolean;
}) {
  const timeString = time?.toLocaleString() || '';
  const timeAgoString = time ? timeAgo(time) : '-';

  return (
    <Tooltip
      label={inverse ? timeAgoString : timeString}
      disabled={disableTooltip}
    >
      <span className={twMerge('whitespace-nowrap', textStyle)}>{inverse ? timeString : timeAgoString}</span>
    </Tooltip>
  );
}
